
import React, { Fragment, useEffect, useState } from 'react'
import { useForm, SubmitHandler } from "react-hook-form";
import axios from 'axios';
import config from 'config';
import { useAuth } from '../hooks/use-auth';
import { removeKeyWithValue } from 'utils';
import { FormLabel, FormInput, FormLabelInputWrapper, ModalSubmit, LoadingContainer } from 'styles/styles';
import { CircularProgress } from '@mui/material';

interface ParentDataProps {
	name: string,
	name_kana: string,
	phone_number: string,
	fax_number: string,
	display_id: string,
	[key: string]: string | number;
}

export const UserInfo = () => {
	const auth = useAuth();
	const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);

	useEffect(() => {
		axios.get('/v0/account/user', {
			headers: auth.authorizationHeader,
		})
			.then((res) => {
				reset(res.data[0]);
			})
			.catch((err) => {
				console.log(err)
			});
	}, [auth]);


	//modal
	const { reset, register, handleSubmit, watch, formState: { errors } } = useForm<ParentDataProps>();
	const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
		let alertList: any[] = [];
		const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
		requiredFields.forEach((key) => {
			if (submitData[key] === undefined || submitData[key] === '') {
				alertList.push(key)
			}
		});
		if (alertList.length) {
			let text = '';
			parentArray.forEach(item => {
				if (alertList.includes(item.field)) {
					text += `${item.title}を埋めてください。\n`;
				}
			});
			if (text !== '') {
				alert(text);
				throw new Error('必須項目が未入力です');
			}
		}
		submitData = removeKeyWithValue(submitData, '');
		const branchData = {
			name: submitData.name,
			name_kana: submitData.name_kana,
			phone_number: submitData.phone_number,
			fax_number: submitData.fax_number,
		}
		try {
			setIsSubmitDisable(true);
			await axios.patch(`/v0/account/user`, branchData, {
				headers: auth.authorizationHeader,
			})
			window.alert("ユーザー情報の更新が完了しました")
		} catch (error: any) {
			window.alert(error.response.data.error);
		}
		setIsSubmitDisable(false);
	};
	//modal end

	//arrayの生成
	const parentArray = [{ title: 'ユーザーID', field: 'display_id', type: 'alphanumeric', disable: true },
	{ title: '氏名', field: 'name', type: 'text', required: true },
	{ title: '氏名（カナ）', field: 'name_kana', type: 'text' },
	{ title: '電話番号', field: 'phone_number', type: 'tel' },
	{ title: 'FAX番号', field: 'fax_number', type: 'tel' }]

	const listItems = parentArray.map((element: any, index) => {
		if (element.title) {
			return (
				<Fragment key={index}>
					<FormLabelInputWrapper>
						<FormLabel htmlFor={element.field}>{element.title}</FormLabel>
						<FormInput {...register(element.field)}
							{...(element.type && { type: config.inputErrorMessage[element.type].type })}
							{...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
							{...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
							{...(element.type && { title: config.inputErrorMessage[element.type].title })}
							{...(element.required && { required: true })}
							{...(element.disable && { disabled: true })}
							{...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
							{...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
						/>
					</FormLabelInputWrapper>
				</Fragment>
			)
		}
	});

	return (
		<>
			<form onSubmit={handleSubmit(onSubmit)}>
				{listItems}
				{isSubmitDisable ? (
					<LoadingContainer>
						<CircularProgress size={20} />
					</LoadingContainer>
				) : (
					<ModalSubmit type="submit" disabled={isSubmitDisable} />
				)}
			</form>
		</>
	)
}
